/* Product detail interactions from the saulemofficial reference, inside the saulemofficial shell. */
(function () {
  'use strict';
  var zone = document.querySelector('#li-merge-products');
  var page = zone && zone.querySelector('.v2-product-detail-page');
  if (!page) return;
  var ZH = !!zone.querySelector('.janm-v2[data-locale="zh"]');
  var closeText = ZH ? '关闭图片' : 'Close image';
  var mainImage = page.querySelector('.v2-product-main-media img');
  var zoomTrigger = page.querySelector('.v2-product-zoom-trigger');
  var thumbs = [].slice.call(page.querySelectorAll('.v2-product-thumbnails button'));

  thumbs.forEach(function (button) {
    button.addEventListener('click', function () {
      var image = button.querySelector('img');
      if (!image || !mainImage) return;
      mainImage.src = image.getAttribute('src');
      thumbs.forEach(function (item) {
        var active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    });
  });

  function closeZoom() {
    var portal = zone.querySelector('.v2-product-zoom-portal');
    if (portal) portal.remove();
    document.documentElement.style.overflow = '';
    if (zoomTrigger) zoomTrigger.setAttribute('aria-expanded', 'false');
  }
  if (zoomTrigger) zoomTrigger.addEventListener('click', function () {
    var portal = document.createElement('div');
    portal.className = 'janm-v2 v2-product-zoom-portal';
    portal.innerHTML = '<div class="v2-catalog-overlay" data-zoom-close></div>' +
      '<div class="v2-product-zoom-dialog" role="dialog" aria-modal="true" tabindex="-1">' +
      '<button class="v2-icon-button" type="button" data-zoom-close aria-label="' + closeText + '">×</button>' +
      '<img alt="' + (mainImage.alt || '') + '" src="' + mainImage.getAttribute('src') + '"></div>';
    zone.appendChild(portal);
    portal.querySelectorAll('[data-zoom-close]').forEach(function (el) { el.addEventListener('click', closeZoom); });
    zoomTrigger.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    portal.querySelector('[role=dialog]').focus();
  });

  var tabs = [].slice.call(page.querySelectorAll('[role=tab]'));
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (item) {
        var active = item === tab;
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.tabIndex = active ? 0 : -1;
        var panel = document.getElementById(item.getAttribute('aria-controls'));
        if (panel) panel.hidden = !active;
      });
    });
    tab.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      var direction = event.key === 'ArrowRight' ? 1 : -1;
      var next = tabs[(tabs.indexOf(tab) + direction + tabs.length) % tabs.length];
      next.focus();
      next.click();
    });
  });

  var primary = page.querySelector('.v2-product-primary-action');
  if (primary) primary.classList.add('li-detail-inquiry-action');
  var mobileAction = page.querySelector('.v2-product-mobile-action button');
  if (mobileAction && primary) mobileAction.addEventListener('click', function () { primary.click(); });
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeZoom(); });
})();
